import React from 'react';
import PropTypes from 'prop-types';

import BackgroundImageCard from '../../../components/BackgroundImageCard';
import TextWithAccordionListItemsCard from '../../../components/TextWithAccordionListItemsCard';
import TextBannerLarge from '../../../components/TextBannerLarge';
import CenteredImageWithText from '../../../components/CenteredImageWithText';
import TextBlock from '../../../components/TextBlock';
import IconListItemsAccordion from '../../../components/IconListItemsAccordion';
import PricingSection from '../../../components/PricingSection';
import StickyButton from '../../../components/StickyButton';
import TextBannerSmall from '../../../components/TextBannerSmall';
import ContentSectionListCard from '../../../components/ContentSectionListCard';

import COMPONENT_TYPE from './componentType';

import './index.scss';

const ProductPageComponentsMapper = {
  [COMPONENT_TYPE.backgroundImageCard]: BackgroundImageCard,
  [COMPONENT_TYPE.textWithAccordionListItemsCard]:
    TextWithAccordionListItemsCard,
  [COMPONENT_TYPE.textBannerLarge]: TextBannerLarge,
  [COMPONENT_TYPE.centeredImageWithText]: CenteredImageWithText,
  [COMPONENT_TYPE.textBlock]: TextBlock,
  [COMPONENT_TYPE.iconListItemsAccordion]: IconListItemsAccordion,
  [COMPONENT_TYPE.pricingSection]: PricingSection,
  [COMPONENT_TYPE.stickyButton]: StickyButton,
  [COMPONENT_TYPE.textBannerSmall]: TextBannerSmall,
  [COMPONENT_TYPE.contentSectionListCard]: ContentSectionListCard,
};

const ProductPageGenerator = ({ data }) => {
  return (
    <>
      {data.items.map((item, key) => {
        const Component = ProductPageComponentsMapper[item.type];
        return (
          <div
            key={`${key}-${item.type}`}
            className={`product-page-generator__${item.type}`}
          >
            <Component {...item.data} />
          </div>
        );
      })}
    </>
  );
};

ProductPageGenerator.propTypes = {
  data: PropTypes.object,
};

export default ProductPageGenerator;
